import { writable, derived } from 'svelte/store';

function createCountdown() {
	const { subscribe, set, update } = writable(0);

    let interval
    let callback
    
    function start(n, cb) {
        callback = cb
        set(n)
        interval = setInterval(updateCountdown, 1000);
    }

    function updateCountdown() {
        update(n => {
            if(n <= 0) {
                stop()
                if(callback) {
                    callback()
                }
                return 0
            }
            return n-1
        })
    }

    function stop() {
		clearInterval(interval);
        set(0)
	};

	return {
        subscribe,
        stop: stop,
		setAndStart: (n, cb) => {stop(); start(n, cb)},
		start: start,
	};
}

export const countdown = createCountdown(0);

export const formatedCountdown = derived(
	countdown,
	$countdown => {
        let m = Math.floor($countdown / 60);
        const s = Math.floor($countdown - m * 60)
        return {
            min: m > 9 ? m : '0'+m,
            sec: s > 9 ? s : '0'+s
        }
    }
);
